import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class PaymentRegisterApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'paymentRegister'
  }

}